var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 34,
    fill: "none",
    viewBox: "0 0 24 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A181E",
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.37 12 11.992 0 4.525-2.508 8.465-6.21 10.507L13 27.286V33c0 .552-.448.999-1 .999-.49 0-.9-.353-.984-.82L11 33v-5.715l-4.79-4.786C2.581 20.498.1 16.673.003 12.26L0 11.992C0 5.37 5.373 0 12 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 15.99c2.181 0 3.95-1.79 3.95-3.998 0-2.207-1.769-3.996-3.95-3.996s-3.95 1.789-3.95 3.996C8.05 14.2 9.82 15.99 12 15.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.f1111d07daf1e95f13f755a5dcccb666.svg";
export { ForwardRef as ReactComponent };